import React, { useContext } from "react";
import { userContext } from "../Context/UserContext";
import Cookies from "js-cookie";

export const authRefReducer = (state, action) => {
    console.log(state);
    switch (action.type) {
        case "LOGIN":
            Cookies.set("refresh", action.refToken);
            return true;

        case "LOGOUT":
            Cookies.remove("refresh");
            return false;

        default:
            return false;
    }
};
